import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { FailedComponent } from './failed/failed.component';
import { RPostAuthenticationComponent } from './rpost-authentication/rpost-authentication.component';
import { RpostAuthenticationLogoutComponent } from './rpost-authentication-logout/rpost-authentication-logout.component';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SocialLoginModule, SocialAuthServiceConfig, GoogleInitOptions } from '@abacritt/angularx-social-login';
import {
  GoogleLoginProvider,
  FacebookLoginProvider
} from '@abacritt/angularx-social-login';
import { EmailAutenticationComponent } from './email-autentication/email-autentication.component';
// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import { ResetPasswordReminderComponent } from './reset-password-reminder/reset-password-reminder.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PasswordExpiredComponent } from './password-expired/password-expired.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';
//import { ErrorInterceptor } from './_helpers/error.interceptor';
import { ReactiveFormsModule } from '@angular/forms';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ResetPasswordSuccessComponent } from './reset-password-success/reset-password-success.component';
import { ResetPasswordErrorComponent } from './reset-password-error/reset-password-error.component';
import { ConversionUtils } from 'turbocommons-ts/utils/ConversionUtils';
import { RpostSsoLogoutComponent } from './rpost-sso-logout/rpost-sso-logout.component';
import { RpostLoginredirectComponent } from './rpost-loginredirect/rpost-loginredirect.component';



const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal
let clientIdPv='';
let postLogoutRedirectUri='';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}
export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  clientIdPv= localStorage.getItem('clienIdLS')!;
  postLogoutRedirectUri = localStorage.getItem("postLogoutRedirectUri")!;

  return new PublicClientApplication({
    
    auth: {
      clientId: environment.azureSSOClientId, 
      authority: 'https://login.microsoftonline.com/common', // PPE testing environment.
      redirectUri: window.location.origin + environment.azureLoginRedirectURI,
      postLogoutRedirectUri: '/',
      navigateToLoginRequestUrl: false // prevents login "loss"
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      //storeAuthStateInCookie: true, // Helps with KMSI scenarios
     storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      loggerOptions: {
        //loggerCallback,
        // added for verbose logging
        loggerCallback: (level: LogLevel, message: string | Error | any, containsPii: boolean) => {
          try {
                if (containsPii) {
                  return;  // skip logging sensitive info
                }
    // Check if message is a string, because only strings have includes method
                if (typeof message === 'string') {
                  if (
                    message.includes('Silent token acquisition failed') ||
                    message.includes('Token renewal operation failed due to timeout') ||
                    message.includes('login_required') ||
                    message.includes('interaction_in_progress') ||
                    message.includes('token_renewal_error') ||
                    message.includes('timeout')
                  ) {
                    console.warn('loggerCallback:Token/Session Warning', message);
                  }
                } else if (message instanceof Error) {
                  console.warn('loggerCallback:ErrorMessage:', message.message); // Handle the case when message is an instance of Error
                  console.warn('loggerCallback:ErrorStackTrace:', message.stack); // Log stack trace if available
                }
                else if (typeof message === 'object' && message !== null) { // Handle message when it's a generic object (not string or Error)
                    console.warn('loggerCallback.ObjectMessage:', message);
                    console.warn('loggerCallback.SerializedObject:', JSON.stringify(message));
                }
                // log everything if environment is not prod
                if ( !environment.production || 
                   message.includes('timeout') ||
                  (environment.production && level === LogLevel.Error)
                )
                {
                      if (typeof message !== 'string') {
                          message = JSON.stringify(message);
                      }

                      var logTextBase64Str=ConversionUtils.stringToBase64(LogLevel[level] + "; " + message);
                        // 2. Call Custom API
                        const logEntry = {
                          ClientId:clientIdPv
                          ,LogText:logTextBase64Str
                          ,Type: 'MSAL.js'
                        };

                      fetch(environment.baseWebAPIUrl+'/api/v1/rcaplog', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(logEntry),
                      })
                      .then(response => {
                        if (!response.ok) {
                          console.error('Failed to send MSAL log to API:', response.status, response.statusText);
                        }
                      })
                      .catch(error => {
                        console.error('Error sending MSAL log to API:', error);
                      });
                }

                switch (level) {
                  case LogLevel.Error:
                    console.error(message);
                    break;
                  case LogLevel.Info:
                    console.info(message);
                    break;
                  case LogLevel.Verbose:
                    console.debug(message);
                    break;
                  case LogLevel.Warning:
                    console.warn(message);
                    break;
            }
        } catch (err) {
          console.error("MSAL Logger internal error:", err);
        }
          
      },
      
        //logLevel: LogLevel.Info,
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false
      }
      ,tokenRenewalOffsetSeconds: 600 //MSAL will try to renew tokens 10 minutes before they expire
      ,windowHashTimeout: 120000 // 120 seconds/2 minutes
      ,navigateFrameWait: 60000 // 60 seconds
      ,loadFrameTimeout: 5000 //5 seconds
      //,asyncPopups: false, // default value is false
      ,allowRedirectInIframe: true

      /* Defaults
        windowHashTimeout	:	9000ms	//timeout period for processing the hash fragment (#) in the URL after a redirect during an authentication flow
        navigateFrameWait	:	500ms	//while acquiring token in background, is the maximum amount of time (in milliseconds) that MSAL will wait for the browser to successfully navigate the hidden iframe to the Microsoft authorization endpoint.
        tokenRenewalOffsetSeconds	:	300s	//early renewal buffer for tokens i.e. 5 minutes before expiry
        loadFrameTimeout : 0 timeout //for loading iframes, how long the library will wait for the hidden iframe to complete its task before considering the renewal attempt a failure
      */
    }
  });
}
// required for AOT compilation
// export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
//   return new TranslateHttpLoader(http);
// }
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
   protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.
  //protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', ['user.read']);

  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Popup,
    authRequest: {
      //scopes: ['user.read'] //microsft graph aPI
      //scopes: ["api://8f491afb-add0-4cd4-82a5-f9e477d6a057/.default"], // client ID of the API
      scopes: ["api://"+environment.scopeId+"/.default"], // client ID of the API
      prompt: 'select_account', // Forces account selection, may reduce KMSI prompts
    },
    loginFailedRoute: '/login-failed'
  };
}
const googleLoginOptions: GoogleInitOptions = {
  oneTapEnabled: false, // default is true
  scopes: 'https://www.googleapis.com/auth/calendar.readonly'
}; // https://developers.google.com/identity/oauth2/web/guides/use-token-model#initialize_a_token_client

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    FailedComponent,
    RPostAuthenticationComponent,
    RpostAuthenticationLogoutComponent,
    HeaderComponent,
    FooterComponent,
    EmailAutenticationComponent,
    ResetPasswordReminderComponent,
    ResetPasswordComponent,
    PasswordExpiredComponent,
    ErrorpageComponent,
    PasswordResetComponent,
    ResetPasswordSuccessComponent,
    ResetPasswordErrorComponent,
    RpostSsoLogoutComponent,
    RpostLoginredirectComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatButtonModule,
    MatToolbarModule,
    MatListModule,
    MatMenuModule,
    HttpClientModule,
    MsalModule,
    SocialLoginModule,
    // ngx-translate and the loader module
    HttpClientModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    //{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.googleSSOClientId,googleLoginOptions
            )
          }
          /* ,
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('clientId')
          } */
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { 

  constructor(private route: ActivatedRoute) {
    //alert(this.route.snapshot.queryParamMap.get('clientId'));
    //this.route.params.subscribe( params => clientIdPv =(params['clientId']));
    //clientIdPv=localStorage.getItem('clienIdLS')!;
    //alert(clientIdPv);
    //alert(this.clientId);
    //localStorage.setItem("clienIdLS",this.clientId); */
   }

   ngOnInit(): void {
    /* let clientIdPv=0;
    this.route.paramMap.subscribe((params: ParamMap) => {
      clientIdPv= +params.get('clientId')!
    })
    alert(clientIdPv); */
  }
}
